import React from 'react';

const Unauthorized = ({ onBackToDashboard, additionalParamMap }) => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <h2>Unauthorized Access</h2>
        <p>You are not authorized to access this resource. Please authenticate to continue.</p>
    
        {!additionalParamMap?.isPreselected && (
          <button 
            className="btn btn-primary"
            onClick={() => {
              if (onBackToDashboard) {
                onBackToDashboard();
              }
            }}
          >
            Back to Dashboard
          </button>
        )}
      </div>
    </div>
  );
};

export default Unauthorized;
